export default {"src":"/_next/static/media/skills.d7f63b0d.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};